var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3.83334C3.375 3.15366 3.75 2.54428 4.3125 2.23959V6.83334H5.4375V1.95834H6.5625V6.83334H7.6875V2.23959C8.22656 2.54428 8.625 3.15366 8.625 3.83334V6.83334H9.75V3.83334C9.75 2.19272 8.39062 0.833344 6.75 0.833344H5.25C3.58594 0.833344 2.25 2.19272 2.25 3.83334V6.83334H3.375V3.83334ZM11.2031 8.84897L10.9453 8.09897C10.8516 7.79428 10.5703 7.58334 10.2422 7.58334H1.73438C1.40625 7.58334 1.125 7.79428 1.03125 8.09897L0.773438 8.84897C0.609375 9.34116 0.984375 9.83334 1.5 9.83334V12.4583C1.5 12.6693 1.66406 12.8333 1.875 12.8333H2.625C2.8125 12.8333 3 12.6693 3 12.4583V9.83334H9V12.4583C9 12.6693 9.16406 12.8333 9.375 12.8333H10.125C10.3125 12.8333 10.5 12.6693 10.5 12.4583V9.83334C10.9922 9.83334 11.3672 9.34116 11.2031 8.84897Z",
    fill: "#o999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.ac17fb7a.svg";
export { ForwardRef as ReactComponent };